import { type ReactNode } from 'react';
import { Modal } from '@/components/ui/modal';
import { useRangeSubmit, type RangeFormMode } from '../hooks/use-range-submit';
import { validateTiers } from '../utils/validate-tiers';
import { RangeFormFields } from './range-form-fields';
import {
  ErrorList,
  ModalActions,
  useFormState,
  type FormBodyProps,
} from './range-form-internals';

export type { RangeFormMode };

type Props = { mode: RangeFormMode | null; onClose: () => void };

function RangeFormBody(p: FormBodyProps): ReactNode {
  return (
    <>
      <RangeFormFields
        state={p.state}
        setState={p.setState}
        disableBounds={p.isEdit}
      />
      <div className="mt-md">
        <ErrorList errors={p.errors} />
      </div>
      <ModalActions
        onClose={p.onClose}
        onSubmit={p.onSubmit}
        disabled={p.disabled}
        isPending={p.isPending}
      />
    </>
  );
}

export function RangeFormModal({ mode, onClose }: Props): ReactNode {
  const [state, setState] = useFormState(mode);
  const isEdit = mode?.kind === 'edit';
  const errors = validateTiers(state.tiers);
  const { submit, isPending } = useRangeSubmit(mode, state, onClose);
  const onSubmit = (): void => {
    if (!errors.length) submit();
  };
  const title = isEdit ? 'Editar tiers del rango' : 'Nuevo rango';
  return (
    <Modal open={!!mode} onClose={onClose} title={title}>
      <RangeFormBody
        state={state}
        setState={setState}
        isEdit={isEdit}
        errors={errors}
        onClose={onClose}
        onSubmit={onSubmit}
        disabled={isPending || errors.length > 0}
        isPending={isPending}
      />
    </Modal>
  );
}
